/**
 * Loading spinner component - colored dots spinning around the center logo
 */

import './LoadingSpinner.css'

interface LoadingSpinnerProps {
  message?: string
  size?: 'small' | 'medium' | 'large'
}

export const LoadingSpinner = ({ message, size = 'medium' }: LoadingSpinnerProps) => {
  const sizeMap = {
    small: 60,
    medium: 100,
    large: 150,
  }
  const spinnerSize = sizeMap[size]
  const logoSize = spinnerSize * 0.5

  return (
    <div className="loading-spinner-container">
      <div className="loading-spinner-wrapper" style={{ width: spinnerSize, height: spinnerSize }}>
        {/* Center logo (static) */}
        <img
          src="/images/logo_center.png"
          alt=""
          className="spinner-center-logo"
          style={{ width: logoSize, height: logoSize }}
        />
        {/* Spinning dots around the logo */}
        <div className="loading-spinner" style={{ width: spinnerSize, height: spinnerSize }}>
          <div
            className="spinner-dot"
            style={{ '--dot-color': '#f39c12', '--dot-index': 0 } as React.CSSProperties}
          />
          <div
            className="spinner-dot"
            style={{ '--dot-color': '#e67e22', '--dot-index': 1 } as React.CSSProperties}
          />
          <div
            className="spinner-dot"
            style={{ '--dot-color': '#f1c40f', '--dot-index': 2 } as React.CSSProperties}
          />
          <div
            className="spinner-dot"
            style={{ '--dot-color': '#1abc9c', '--dot-index': 3 } as React.CSSProperties}
          />
          <div
            className="spinner-dot"
            style={{ '--dot-color': '#3498db', '--dot-index': 4 } as React.CSSProperties}
          />
          <div
            className="spinner-dot"
            style={{ '--dot-color': '#2980b9', '--dot-index': 5 } as React.CSSProperties}
          />
          <div
            className="spinner-dot"
            style={{ '--dot-color': '#9b59b6', '--dot-index': 6 } as React.CSSProperties}
          />
          <div
            className="spinner-dot"
            style={{ '--dot-color': '#34495e', '--dot-index': 7 } as React.CSSProperties}
          />
          <div
            className="spinner-dot"
            style={{ '--dot-color': '#27ae60', '--dot-index': 8 } as React.CSSProperties}
          />
          <div
            className="spinner-dot"
            style={{ '--dot-color': '#2ecc71', '--dot-index': 9 } as React.CSSProperties}
          />
        </div>
      </div>
      {message && <p className="loading-message">{message}</p>}
    </div>
  )
}
